import { MdLanguage } from 'react-icons/md';
import { DropdownMenu } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { REGISTERED_LANGUAGES } from '~/shared/constants/i18n';
import { normalizeLanguage } from '~/shared/utils/string';

import { useLanguageDropdown } from './hooks';

type LanguageDropdownProps = {
  currentLanguage?: string;
};

export const LanguageDropdownHeader = ({
  currentLanguage
}: LanguageDropdownProps) => {
  const { t } = useTranslate();
  const { handleLanguageChange } = useLanguageDropdown();

  const languageOptions = REGISTERED_LANGUAGES.map(lang => ({
    label: t(`languages.${lang}`),
    onSelect: () => handleLanguageChange(lang)
  }));

  const displayLanguage = normalizeLanguage(currentLanguage);
  const userLanguageLabel = t(`languages.${displayLanguage}`);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-100 border-none bg-transparent cursor-pointer"
          title={userLanguageLabel}>
          <MdLanguage size={20} />
          <span className="hidden lg:inline text-sm">{userLanguageLabel}</span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" className="min-w-[150px]">
        {languageOptions.map(option => (
          <DropdownMenu.Item
            key={option.label}
            onSelect={option.onSelect}
            className="cursor-pointer">
            {option.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
